import { Editor, Transforms, Node as SlateNode, Element } from 'slate';

function withPageBreaks(editor) {

	const { normalizeNode } = editor;
	editor.normalizeNode = (entry) => {
		const [node, path] = entry;
		if (Element.isElement(node) && node.pageBreaks && Array.isArray(node.pageBreaks) && node.pageBreaks.length > 0) {
			const textLen = SlateNode.string(node).length;
			const clamped = node.pageBreaks.map(pb =>
				pb.offset > textLen ? { ...pb, offset: textLen } : pb
			);
			const needsUpdate = clamped.some((pb, i) => pb !== node.pageBreaks[i]);
			if (needsUpdate) {
				Transforms.setNodes(editor, { pageBreaks: clamped }, { at: path });
				return;
			}
		}
		normalizeNode(entry);
	};

	editor.addPageBreak = (pageBreak, path) => {
		try {
			const nodeEntry = Editor.node(editor, path)
			const node = nodeEntry[0];
			let pageBreaks = [];
			if (node.pageBreaks && Array.isArray(node.pageBreaks)) {
				// Remove the entry being replaced (by id) AND any other entry
				// at the same character offset. Two breaks at the same offset
				// on the same node is never valid — this also cleans up orphaned
				// entries left by state/node desync.
				pageBreaks = node.pageBreaks.filter(p =>
					p.id !== pageBreak.pageBreakId && p.offset !== pageBreak.offset
				);
			}
			pageBreaks.push({pos:pageBreak.pos, id:pageBreak.pageBreakId, offset: pageBreak.offset});
			Transforms.setNodes(editor, {
				pageBreaks:pageBreaks
			}, {
				at:path
			});
	
		} catch (error) {
			//console.log("### ERROR", error)
		}
	}

	editor.removePageBreak = (pageBreak, path) => {
		try {
			const nodeEntry = Editor.node(editor, path)
			const node = nodeEntry[0];
			const pageBreaks = [];
			if (node.pageBreaks && Array.isArray(node.pageBreaks)) {
				node.pageBreaks.forEach(p => {
					if (p.id !== pageBreak.pageBreakId) {
						pageBreaks.push(p)
					}
				})
			}
			Transforms.setNodes(editor, {
				pageBreaks:pageBreaks
			}, {
				at:path
			});
		} catch (error) {
			console.log(error)
		}
	}

	editor.getPageBreakNode = (path) => {
		return Editor.node(editor, path);
	} 

	editor.getAllPageBreaks = (end) => {
		const match = Editor.nodes(editor, {
			at: {
				anchor: {path:[0]},
				focus: {path:[end]}
			},
			match: n => n.pageBreaks && n.pageBreaks.length > 0
		})
		return match;
	}

	return {editor:editor};
		
}
export default withPageBreaks